/**
 * PasswordGate - client-side password wall for staging previews.
 *
 * Only active when REACT_APP_STAGING_PASSWORD is set (Vercel env var).
 * In local dev (no env var), renders children transparently.
 * Stores auth in sessionStorage so it persists across refreshes
 * but clears when the browser tab closes.
 */
import React, { useState } from "react";

const STORAGE_KEY = "staging_authenticated";

export default function PasswordGate({ children }) {
  const requiredPassword = process.env.REACT_APP_STAGING_PASSWORD;

  // No password configured - pass through (local dev)
  if (!requiredPassword) return children;

  const [authenticated, setAuthenticated] = useState(
    () => sessionStorage.getItem(STORAGE_KEY) === "true"
  );
  const [input, setInput] = useState("");
  const [error, setError] = useState(false);

  if (authenticated) return children;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (input === requiredPassword) {
      sessionStorage.setItem(STORAGE_KEY, "true");
      setAuthenticated(true);
    } else {
      setError(true);
      setInput("");
    }
  };

  return (
    <div style={styles.backdrop}>
      <form onSubmit={handleSubmit} style={styles.card}>
        <h2 style={styles.heading}>Gitcha Staging Preview</h2>
        <p style={styles.subtext}>Enter the password to continue.</p>
        <input
          type="password"
          value={input}
          onChange={(e) => { setInput(e.target.value); setError(false); }}
          placeholder="Password"
          autoFocus
          style={{
            ...styles.input,
            borderColor: error ? "#e53e3e" : "#d1d5db",
          }}
        />
        {error && <p style={styles.error}>Incorrect password</p>}
        <button type="submit" style={styles.button}>
          Continue
        </button>
      </form>
    </div>
  );
}

const styles = {
  backdrop: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    background: "#f5f5f5",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  },
  card: {
    background: "#fff",
    borderRadius: 12,
    padding: "40px 32px",
    maxWidth: 380,
    width: "100%",
    boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
    textAlign: "center",
  },
  heading: {
    margin: "0 0 8px",
    fontSize: 22,
    fontWeight: 700,
    color: "#1a1a2e",
  },
  subtext: {
    margin: "0 0 24px",
    fontSize: 14,
    color: "#6b7280",
  },
  input: {
    width: "100%",
    padding: "12px 16px",
    fontSize: 16,
    border: "1.5px solid #d1d5db",
    borderRadius: 8,
    outline: "none",
    boxSizing: "border-box",
    marginBottom: 8,
  },
  error: {
    color: "#e53e3e",
    fontSize: 13,
    margin: "0 0 8px",
  },
  button: {
    width: "100%",
    padding: "12px",
    fontSize: 16,
    fontWeight: 600,
    color: "#fff",
    background: "#1a1a2e",
    border: "none",
    borderRadius: 8,
    cursor: "pointer",
    marginTop: 8,
  },
};
